import { useEffect, useState } from "react";
import MaterialTable, { MTableAction, MTableBody, MTableToolbar } from "material-table";
import {
    Box,
    Grid,
    CircularProgress,
    Button,
    FormControl,
    Typography,
    TextField,
    IconButton,
    Tooltip,
} from "@mui/material";
import { GenerateEPFOReportHelper } from "../../helper/Reports/GetWageReportHelper";
import CustomToggle from "../../../Base/views/CustomToggle";
import { CSVLink } from "react-csv";
import CommonDatePicker from "../../../Base/views/CommonDatePicker";
import { useDispatch, useSelector } from "react-redux";
import { currentMonth } from "../../../Base/helper/baseFunctions";
import { GetWageReportAction } from "../../../../../store/Finance/Reports/Action";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { toast } from "react-toastify";
import { GetRegistrationNumberAction } from "../../../../../store/Finance/PayDate/Action";
import Popup from "../../../Base/views/Popup";
import { AddEsicEpfoShortcutHelper } from "../../../FinanceSettings/helper/finance";
import { useTheme, useMediaQuery } from "@mui/material";
import SelectableMultiSelect from "../../../Base/views/SelectableMultiSelect";

const EPFOLandingPage = () => {
    const theme = useTheme();
    const isLarge = useMediaQuery(theme.breakpoints.only("lg"));
    const [isLoadingbtn, setIsLoadingbtn] = useState(false);
    const [data, setData] = useState([]);
    const [inactive, setInactive] = useState(false);
    const date = new Date();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [isCsvLoading, setIsCsvLoading] = useState(false);
    const [openPopup, setOpenPopup] = useState(false);
    const [type, setType] = useState("")
    const [currentData, setCurrentData] = useState({});
    const [errors, setErrors] = useState("");
    const { wage_report_data } = useSelector(
                (state) => state?.FinanceReducer.WageReportsReducer
            );
    const { open, fixedMenu, isMobile } = useSelector(
        (state) => state?.MenuReducer
    );
    const { registration_number_data } = useSelector(
        (state) => state.FinanceReducer?.PayDateReducer
    );
    const { minDojYear } = useSelector(state => state?.AncillaryReducer?.WorkSpaceDojReducer);
    const [filters, setFilters] = useState({
        month_year: `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`,
        ats_work_location_id: []
    });
    const { workLocationAccess_options } = useSelector(state => state?.AncillaryReducer?.WorkLocationReducer);
    const [warningMessage, setWarningMessage] = useState("");
    const transformData = (epfoData = [], ecrData = []) => {
        return epfoData?.map((epfoItem, index) => {
            const ecrItem = ecrData?.[index] || {};
            return {
                name: epfoItem?.["employee name"] || "N/A",
                work_location_name: epfoItem?.["work_location_name"] || "N/A",
                uan: epfoItem?.uan,
                employee_pf_reg_no: epfoItem?.["employee_pf_reg_no"],
                gross: (epfoItem?.uan && epfoItem?.employee_pf_reg_no) ? Number(epfoItem?.["gross wages"] || 0).toFixed(2) : "-",
                epfcr: (epfoItem?.uan && epfoItem?.employee_pf_reg_no) ? Number(epfoItem?.["epf contribution remitted"] || 0).toFixed(2) : "-",
                epscr: (epfoItem?.uan && epfoItem?.employee_pf_reg_no) ? Number(epfoItem?.["eps contribution remitted"] || 0).toFixed(2) : "-",
                epfeps: (epfoItem?.uan && epfoItem?.employee_pf_reg_no) ? Number(epfoItem?.["epf and eps diff remitted"] || 0).toFixed(2) : "-",
                ncp: (epfoItem?.uan && epfoItem?.employee_pf_reg_no) ? Number(epfoItem?.["ncp days"] || 0).toFixed(2) : "-",
                epf: (epfoItem?.uan && epfoItem?.employee_pf_reg_no) ? Number(epfoItem?.["epf wages"] || 0).toFixed(2) : "-",
                eps: Number(epfoItem?.["eps wages"] || 0).toFixed(2),
                edli: Number(epfoItem?.["edli wages"] || 0).toFixed(2),
                edli_contribution: (epfoItem?.uan && epfoItem?.employee_pf_reg_no) ? Number(epfoItem?.["edli contribution"] || 0).toFixed(2) : "-",
                epf_admin_charges: (epfoItem?.uan && epfoItem?.employee_pf_reg_no) ? Number(epfoItem?.["epf admin charges"] || 0).toFixed(2) : "-",

                paidDays: ecrItem?.employee_esi_reg_no ? Number(ecrItem?.["paid days"] || 0) : "-",
                employee_id: ecrItem?.["employee_id"],
                esi_no: ecrItem?.["employee_esi_reg_no"],
                wages: ecrItem?.employee_esi_reg_no ? Number(ecrItem?.["wages"] || 0).toFixed(2) : "-",
                employeecontribution: ecrItem?.employee_esi_reg_no ? Number(ecrItem?.["employee contribution"] || 0).toFixed(2) : "-",
                employercontribution: ecrItem?.employee_esi_reg_no ? Number(ecrItem?.["employer contribution"] || 0).toFixed(2) : "-",

            };
        }) || [];
    };
    const handleGenerate = () => {
        const [f_year, month] = filters.month_year.split("-");
        const f_month = parseInt(month, 10).toString();
        setIsLoadingbtn(true);
        if (!registration_number_data?.pf_no && !inactive) {
            setWarningMessage("Please configure EPF number of the organization for successful EPF report generation.");
            setIsLoadingbtn(false);
            setTimeout(() => {
                setWarningMessage("");
            },10000);
            return;
        }
        if (!registration_number_data?.esi_no && inactive) {
            setWarningMessage("Please configure ESI number of the organization for successful ESI report generation.");
            setIsLoadingbtn(false);
            setTimeout(() => {
                setWarningMessage("");
            },10000);
            return;
        }
        setWarningMessage("");
        GenerateEPFOReportHelper({
            month: f_month,
            year: f_year,
            tab: inactive ? 'ESI' : 'EPF'
        }).then((res) => {
            if (res?.data?.statuscode === 200) {
                const epfoData = res?.data?.data?.[0]?.data_json || [];
                const ecrData = res?.data?.data?.[0]?.data_json || [];
                const transformedData = transformData(epfoData, ecrData);
                setData(transformedData);
            } else if (res?.data?.statuscode === 500) {
                toast.error(res?.data?.error?.[0]?.message)
            }
            setIsLoadingbtn(false);
        });
    };
    const handleToggle = (e) => {
        setInactive(!inactive);
        setErrors({})
    };
    const headers = [
        { label: "Name", key: "name" },
        { label: "UAN No.", key: "uan" },
        { label: "EPF No.", key: "employee_pf_reg_no" },
        { label: "ESI No.", key: "esi_no" },
        { label: "Gross Earned Wages", key: "gross" },
        { label: "EPF Wages", key: "epf"},
        { label: "EPF Contribution Remitted (12%)", key: "epfcr" },
        { label: "EPS Contribution Remitted (8.33%)", key: "epscr" },
        { label: "EPF and EPS Diff Remitted (3.67%)", key: "epfeps" },
        { label: "NCP Days", key: "ncp" },
        { label: "EPF Admi Charges (0.5% of EPF Wages)", key: "edli_contribution" },
        { label: "EDLI Contribuion (0.5% of EDLI Wages)", key: "epf_admin_charges" },
        { label: "Paid Days", key: "paidDays" },
        { label: "ESI Wages", key: "wages" },
        { label: "Employee Contribution (0.75%)", key: "employeecontribution" },
        { label: "Employer Contribution (3.25%)", key: "employercontribution" }
    ];
    const handleFilter = (event) => {
        if (["month_year"].includes(event?.target?.name)) {
            setData([]);
            setFilters({ ...filters, [event?.target?.name]: event?.target?.value });
            const [f_year, month] = event?.target?.value.split("-");
            const f_month = parseInt(month, 10).toString();
            dispatch(GetWageReportAction({ month: f_month, year: f_year }));
        }
        
    };

    const formatDate = () => {
        const date = new Date();
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = String(date.getFullYear()).slice(-2);
        return `${day}_${month}_${year}`;
    };
    const csvFileName = `EPFO_ECR_${formatDate()}.csv`;
    const csvFileNameEpf = `EPF_${formatDate()}.csv`;
    const exportFileName = inactive ? `ESI_${formatDate()}` : `EPF_${formatDate()}`;
    
    const fetchData = () => {
        const [f_year, month] = filters.month_year.split("-");
        const f_month = parseInt(month, 10).toString();
        const locationPayload = JSON.stringify((filters?.ats_work_location_id || [])?.map((item) => ({ ats_work_location_id: item?.work_location_id })));
        setIsLoading(true);
        GenerateEPFOReportHelper({
            month: f_month, year: f_year,
            tab: inactive ? 'ESI' : 'EPF',
            ats_work_location_json: (filters?.ats_work_location_id || [])?.length > 0 ? locationPayload : null,
        }).then((res) => {
            const epfoData = res?.data?.data?.[0]?.data_json || [];
            const ecrData = res?.data?.data?.[0]?.data_json || [];
            const transformedData = transformData(epfoData, ecrData);
            setData(transformedData);
            setIsLoading(false);
        });
    }
    useEffect(() => {
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inactive, filters, registration_number_data?.pf_no, registration_number_data?.esi_no]);
    useEffect(() => {
        const f_month = parseInt(currentMonth(), 10).toString();
        dispatch(GetWageReportAction({ month: f_month, year: date.getFullYear() }));
        dispatch(GetRegistrationNumberAction())
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

      const handleExport = (type) => {
            setIsCsvLoading(true);
            try {
                const headers = [
                   { label: "Name", key: "name" },
                   { label: "Work Location", key: "work_location_name" },
                    { label: "UAN No.", key: "uan" },
                    { label: "EPF No.", key: "employee_pf_reg_no" },
                    { label: "Gross Earned Wages", key: "gross" },
                    { label: "EPF Wages", key: "epf"},
                    { label: "EPF Contribution Remitted (12%)", key: "epfcr" },
                    { label: "EPS Contribution Remitted (8.33%)", key: "epscr" },
                    { label: "EPF and EPS Diff Remitted (3.67%)", key: "epfeps" },
                    { label: "NCP Days", key: "ncp" },
                    { label: "EPF Admi Charges (0.5% of EPF Wages)", key: "edli_contribution" },
                    { label: "EDLI Contribuion (0.5% of EDLI Wages)", key: "epf_admin_charges" },
                ];
                const headers1 = [
                    { label: "Name", key: "name" },
                    { label: "Work Location", key: "work_location_name" },
                    { label: "ESI No.", key: "esi_no" },
                    { label: "Paid Days", key: "paidDays" },
                    { label: "ESI Wages", key: "wages" },
                    { label: "Employee Contribution (0.75%)", key: "employeecontribution" },
                    { label: "Employer Contribution (3.25%)", key: "employercontribution" }
                ];
                const csvData = [];
                if (type === "EPF") {
                    csvData.push(headers?.map(header => header.label))
                    data?.filter(el => (el?.uan && el?.employee_pf_reg_no))?.forEach(row => {
                        const rowData = headers.map(header => row[header.key]);
                        csvData.push(rowData);
                    });
                }
                if (type === "ESI") {
                    csvData.push(headers1?.map(header => header.label))
                    data?.filter(el => (el?.esi_no))?.forEach(row => {
                        const rowData = headers1.map(header => row[header.key]);
                        csvData.push(rowData);
                    });
                }
                const csv = csvData.map(row => row.join(",")).join("\n");
                const blob = new Blob([csv], { type: "text/csv" });
                const url = URL.createObjectURL(blob);
                const downloadLink = document.createElement("a");
                downloadLink.href = url;
                downloadLink.download = type === "ESI" ? exportFileName : csvFileNameEpf;
                downloadLink.setAttribute("target", "_blank");
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
                URL.revokeObjectURL(url);
            } catch (err) {
                toast.error(`Error generating CSV: ${err.message}`)
            } finally {
                setIsCsvLoading(false);
            }
        };
    const initialData = {
        pf_no: "",
        esi_no: "",
        uan: ""
      }
    const [regData, setRegData] = useState(initialData)
    const validate = (fieldValues) => {
        let temp = { ...errors };
        if ("uan" in fieldValues && type === "UAN") {
        temp.uan =
            fieldValues?.uan === "" || fieldValues?.uan === null
            ? ""
            : fieldValues?.uan.toString() !== "" &&
                !fieldValues?.uan?.toString()?.match(/^\(?[0-9]{12}$/)
                ? "Invalid UAN Number."
                : "";
        }
        if ("esi_no" in fieldValues && type === "ESI") {
        temp.esi_no =
            fieldValues.esi_no === "" || fieldValues.esi_no === null
            ? ""
            : fieldValues.esi_no.toString() !== "" &&
                !fieldValues.esi_no.toString().match(/^\d{10}$/)
                ? "Invalid ESI Number."
                : "";
        }
        if ("pf_no" in fieldValues && type === "EPF") {
        temp.pf_no =
            fieldValues.pf_no === "" || fieldValues.pf_no === null
            ? ""
            : fieldValues.pf_no.toString() !== "" &&
                !fieldValues.pf_no.toString().match(/^[A-Z]{2}\/[A-Z]{3}\/\d{7}\/\d{3}\/\d{7}$/)
                ? "Invalid EPF Number."
                : "";
        }
        setErrors({
        ...temp,
        });
        const temp1 = { ...temp };
        return Object.values(temp1).every((x) => x === "");
    };
    const handleInputChange = (event, value) => {
        setRegData({
        ...regData,
        [event.target.name]: event.target.value,
        });
        Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ ...regData, [event.target.name]: event.target.value });
    };
      const handleAdd = (rowData, labelType) => {
        setRegData({
            pf_no: rowData?.employee_pf_reg_no || "",
            esi_no: rowData?.esi_no || "",
            uan: rowData?.uan || "",
        });
            setOpenPopup(true);
            setType(labelType);
            setCurrentData(rowData);
     }
      const handleAddEsicEpfo = () => {
        if (!validate(regData)) return;
        AddEsicEpfoShortcutHelper({
          employee_fk: currentData?.employee_id,
          pf_no: regData?.pf_no,
          esi_no: regData?.esi_no,
          uan: String(regData?.uan),
         }).then((res) => {
          if (res?.data?.statuscode === 200) {
              setOpenPopup(false);
              fetchData();
            }
        })
      }
    const [worklocationData, setWorklocationData] = useState({
                load: true,
                values: [],
            });
    const handleWorkLoacation = () => {
        if(workLocationAccess_options) {
            setWorklocationData({ load: false, values: workLocationAccess_options || [] })
        } else {
            setWorklocationData({ load: false, values: [] })
        }
    }
    useEffect(() => {
        handleWorkLoacation();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[workLocationAccess_options])
    const handleFilterChange = (event, value) => {
        if (["ats_work_location_id"].includes(event)) {
        if (value) {
            setFilters({ ...filters, [event]: value });
        } else {
            setFilters({ ...filters, [event]: "" });
        }
        }
    }
    return (
            <Box sx={{ maxHeight: "calc(100vh - 125px)", overflowY: "auto" }}>
                <Box sx={{ m: 1 }}>
                    <Grid sx={{ display: "flex", justifyContent: "space-between" }} container columnSpacing={1} mb={1}>
                        <FormControl>
                            <CommonDatePicker
                                name="month_year"
                                openTo="month"
                                views={['year', 'month']}
                                label="Month and Year"
                                pickerType="date"
                                size="small"
                                onKeyDown={(e) => e.preventDefault()}
                                onKeyPress={(e) => e.preventDefault()}
                                pickerFormat="MM/yyyy"
                                DefaultDTvalue={filters.month_year}
                                maxDate={new Date()}
                                // minDate={new Date(minDojYear)}
                                minDate={new Date(new Date(minDojYear).setFullYear(new Date(minDojYear).getFullYear() - 1))}
                                handleChange={(value) =>
                                    handleFilter({
                                        target: {
                                            name: "month_year",
                                            value: value
                                                ? `${value?.getFullYear()}-${("0" + (value?.getMonth() + 1)).slice(-2)}-${("0" + value?.getDate()).slice(-2)}`
                                                : "",
                                        },
                                    })
                                }
                            />
                        </FormControl>
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                                { warningMessage && (
                                <Box sx={{ display: "flex", alignItems: "center", paddingRight: "10px" }}>
                                    <WarningAmberIcon color="warning" sx={{ fontSize: 14 }} />
                                    <Typography
                                        variant="caption"
                                        sx={{ color: "#ffcb2e", fontSize: "0.75rem" }}
                                        >
                                        {warningMessage}
                                    </Typography>
                                </Box>
                            )}
                            <div>
                                {isLoadingbtn ? (
                                    <CircularProgress disableShrink />
                                ) : (
                                    <Button
                                        onClick={handleGenerate}
                                        className="mpl-primary-btn"
                                        disabled={ wage_report_data?.length === 0}
                                    >
                                        { ((!registration_number_data?.pf_no && !inactive) || (!registration_number_data?.esi_no && inactive)) ? "Generate" : data?.length > 0 ? "Regenerate" : "Generate"}
                                    </Button>
                                )}
                            </div>
                            {data?.length > 0 && (
                                <Button sx={{ ml: 2 }} className="mpl-primary-btn">
                                    <CSVLink className="ats-csv-btn" data={data?.filter(el => (el?.uan && el?.employee_pf_reg_no && el?.esi_no))} headers={headers} filename={csvFileName}>
                                        Export All
                                    </CSVLink>
                                </Button>
                            )}
                        </Box>
                    </Grid>
                </Box>
                <Box
                    width={
                        isMobile
                        ? "100%"
                        : !fixedMenu && !open
                        ? "calc(100vw - 75px)"
                        : "calc(100vw - 255px)"
                    }
                    >
                    <MaterialTable
                        isLoading={isLoading}
                        columns={[
                            {
                                title: "Name",
                                cellStyle: { padding: "10px 10px 10px 13px", width: "12%" },
                                headerStyle: { padding: "5px 10px 5px 13px", width: "12%" },
                                field: "name",
                                grouping: false,
                            },
                            {
                                title: "Work Location",
                                cellStyle: { padding: "10px 10px 10px 13px", width: "12%" },
                                headerStyle: { padding: "5px 10px 5px 13px", width: "12%" },
                                field: "work_location_name",
                                grouping: false,
                            },
                            {
                                title: "UAN No.",
                                cellStyle: { padding: "10px 10px 10px 13px", width: "12%" },
                                headerStyle: { padding: "5px 10px 5px 13px", width: "12%" },
                                field: "uan",
                                grouping: false,
                                hidden: inactive,
                                render: (rowData) => {
                                    return rowData?.uan ? rowData?.uan : <Button
                                        variant="text"
                                        size="small"
                                        sx={{ fontSize: "0.75rem", minWidth: "auto", padding: "4px 6px" }}
                                        onClick={() => handleAdd(rowData, "UAN")} 
                                        >
                                        {"Add UAN No."}
                                        </Button>;
                                }
                            },
                            {
                                title: "EPF No.",
                                cellStyle: { padding: "10px 10px 10px 13px", width: "12%" },
                                headerStyle: { padding: "5px 10px 5px 13px", width: "12%" },
                                field: "employee_pf_reg_no",
                                grouping: false,
                                hidden: inactive,
                                render: (rowData) => {
                                    return rowData?.employee_pf_reg_no ? rowData?.employee_pf_reg_no : <Button
                                        variant="text"
                                        size="small"
                                        sx={{ fontSize: "0.75rem", minWidth: "auto", padding: "4px 6px" }}
                                        onClick={() => handleAdd(rowData, "EPF")} 
                                        >
                                        {"Add EPF No."}
                                        </Button>;
                                }
                            },
                            {
                                title: "Gross Earned Wages",
                                cellStyle: { padding: "10px 10px 10px 13px", width: "8%" },
                                headerStyle: { padding: "5px 10px 5px 13px", width: "8%" },
                                field: "gross",
                                grouping: false,
                                hidden: inactive,
                            },
                            {
                                title: "EPF Wages",
                                cellStyle: { padding: "10px 10px 10px 13px", width: "8%" },
                                headerStyle: { padding: "5px 10px 5px 13px", width: "8%" },
                                field: "epf",
                                grouping: false,
                                hidden: inactive,
                            },
                            {
                                title: "EPF Contribution Remitted (12%)",
                                cellStyle: { padding: "10px 10px 10px 13px", width: "12%" },
                                headerStyle: { padding: "5px 10px 5px 13px", width: "12%" },
                                field: "epfcr",
                                grouping: false,
                                hidden: inactive,
                            },
                            {
                                title: "EPS Contribution Remitted (8.33%)",
                                cellStyle: { padding: "10px 10px 10px 13px", width: "12%" },
                                headerStyle: { padding: "5px 10px 5px 13px", width: "12%" },
                                field: "epscr",
                                hidden: inactive,
                                grouping: false,
                            }, {
                                title: "EPF and EPS Diff. Remitted (3.67%)",
                                cellStyle: { padding: "10px 10px 10px 13px", width: "10%" },
                                headerStyle: { padding: "5px 10px 5px 13px", width: "10%" },
                                field: "epfeps",
                                grouping: false,
                                hidden: inactive,
                            },
                            {
                                title: "NCP Days",
                                cellStyle: { padding: "10px 10px 10px 13px", width: "8%" },
                                headerStyle: { padding: "5px 10px 5px 13px", width: "8%" },
                                field: "ncp",
                                grouping: false,
                                hidden: inactive,
                            },
                            {
                                title: "ESI No.",
                                cellStyle: { padding: "10px 10px 10px 13px", width: "15%" },
                                headerStyle: { padding: "5px 10px 5px 13px", width: "15%" },
                                field: "esi_no",
                                grouping: false,
                                hidden: !inactive,
                                render: (rowData) => {
                                    return rowData?.esi_no ? rowData?.esi_no : <Button
                                        variant="text"
                                        size="small"
                                        sx={{ fontSize: "0.75rem", minWidth: "auto", padding: "4px 6px" }}
                                        onClick={() => handleAdd(rowData, "ESI")} 
                                        >
                                        {"Add ESI No."}
                                        </Button>;
                                }
                            },
                            {
                                title: "Paid Days",
                                cellStyle: { padding: "10px 10px 10px 13px", width: "15%" },
                                headerStyle: { padding: "5px 10px 5px 13px", width: "15%" },
                                field: "paidDays",
                                grouping: false,
                                hidden: !inactive,
                            },
                            {
                                title: "ESI Wages",
                                cellStyle: { padding: "10px 10px 10px 13px", width: "15%" },
                                headerStyle: { padding: "5px 10px 5px 13px", width: "15%" },
                                field: "wages",
                                grouping: false,
                                hidden: !inactive,
                            },
                            {
                                title: "Employee Contribution (0.75%)",
                                cellStyle: { padding: "10px 10px 10px 13px", width: "20%" },
                                headerStyle: { padding: "5px 10px 5px 13px", width: "20%" },
                                field: "employeecontribution",
                                grouping: false,
                                hidden: !inactive,
                            }, 
                            {
                                title: "Employer Contribution (3.25%)",
                                cellStyle: { padding: "10px 10px 10px 13px", width: "20%" },
                                headerStyle: { padding: "5px 10px 5px 13px", width: "20%" },
                                field: "employercontribution",
                                grouping: false,
                                hidden: !inactive,
                            },
                        ]}
                        data={data}
                        options={{
                            maxBodyHeight: !isLarge ? "calc(100vh - 300px)" : "calc(100vh - 230px)",
                            minBodyHeight: !isLarge ? "calc(100vh - 300px)" : "calc(100vh - 230px)",
                            rowStyle: { fontSize: "13px" },
                            headerStyle: { padding: "5px 10px 5px 13px", fontWeight: "bold" },
                            sorting: true,
                            search: true,
                            searchText: "",
                            searchFieldAlignment: "right",
                            searchAutoFocus: false,
                            searchFieldVariant: "standard",
                            filtering: false,
                            paging: true,
                            pageSizeOptions: [25, 50],
                            pageSize: 25,
                            paginationType: "stepped",
                            showFirstLastPageButtons: false,
                            paginationPosition: "bottom",
                            // exportButton: data?.length > 0 && inactive && {
                            //     csv: false,
                            //     pdf: false,
                            // },
                            exportButton: false,
                            exportAllData: true,
                            exportFileName: exportFileName,
                            addRowPosition: "first",
                            selection: false,
                            actionsColumnIndex: -1,
                            showSelectAllCheckbox: false,
                            showTextRowsSelected: false,
                            grouping: false,
                            columnsButton: false,
                        }}
                        components={{
                        Body: props => 
                            (!registration_number_data?.pf_no && !inactive) ? (
                                <tbody>
                                    <tr>
                                    <td colSpan={props.columns.length}>
                                        <Box
                                        sx={{
                                            height:  !isLarge ? "calc(100vh - 300px)" : "calc(100vh - 230px)",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            color: "#888",
                                            fontSize: "16px",
                                        }}
                                        >
                                        Please configure EPF number of the organization for successful EPF report generation.
                                    </Box>
                                    </td>
                                    </tr>
                                </tbody>
                            ) : (!registration_number_data?.esi_no && inactive) ? (
                                <tbody>
                                    <tr>
                                    <td colSpan={props.columns.length}>
                                        <Box
                                        sx={{
                                            height:  !isLarge ? "calc(100vh - 300px)" : "calc(100vh - 230px)",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            color: "#888",
                                            fontSize: "16px",
                                        }}
                                        >
                                        Please configure ESI number of the organization for successful ESI report generation.
                                    </Box>
                                    </td>
                                    </tr>
                                </tbody>
                            ) :
                            data?.length === 0 ? (
                            <tbody>
                                <tr>
                                <td colSpan={props.columns.length}>
                                    <Box
                                    sx={{
                                        height:  !isLarge ? "calc(100vh - 300px)" : "calc(100vh - 230px)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        color: "#888",
                                        fontSize: "16px",
                                    }}
                                    >
                                    Pay summary not generated for this month-year selection. Please generate it before proceeding.
                                </Box>
                                </td>
                                </tr>
                            </tbody>
                            ) : (
                            <MTableBody {...props} />
                            ),
                        Action: (props) => {
                            const ActionComponent = props?.components?.Action || MTableAction;
                            if (props?.action?.icon && typeof props?.action?.icon === "function") {
                            const IconElement = props?.action?.icon();
                            // Check if the rendered element is CustomToggle
                            if (IconElement?.props?.id === "filters") {
                                return (
                                <Box
                                    sx={{
                                        "& .MuiIconButton-root": {
                                            background: "transparent !important",
                                            boxShadow: "none !important",
                                            padding: "0px !important",
                                            margin: "0px !important",
                                            borderRadius: "0px !important",
                                            "&:hover": {
                                            background: "transparent !important",
                                            },
                                        },
                                        "& .MuiTouchRipple-root": {
                                            display: "none",
                                        },
                                    }}
                                >
                                    <ActionComponent {...props} />
                                </Box>
                                );
                            }
                            }
                            return <ActionComponent {...props} />;
                        },
                        Toolbar: (props) => (
                            <Box sx={{ width: "full", display: "flex", flexDirection: { xs: "column", sm: "row" }, flexGrow: 1 }}>
                                <Box
                                    sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    backgroundColor: "#f3edfd",
                                    padding: "0px 0px 0px 20px",
                                    flexGrow: 1,
                                    minHeight: "48px !important",
                                    }}
                                >
                                    <Box>
                                        <Typography variant='h6'>
                                        {inactive ? "ESI" : "EPF"}
                                        </Typography>
                                    </Box>
                                    <Box sx={{width: "210px", display: "flex", alignItems: "center", pt: 0.5}}>
                                        <SelectableMultiSelect
                                            multiple
                                            label="Work Location"
                                            placeholder="Select Location"
                                            value={filters?.ats_work_location_id}
                                            loading={handleWorkLoacation}
                                            fieldLabel="work_location_name"
                                            name="ats_work_location_id"
                                            size="small"
                                            onChangeEvent={handleFilterChange}
                                            data={worklocationData}
                                            menuHeight={150} // optional
                                        />
                                    </Box> 
                                </Box>
                                <Box
                                    sx={{
                                        "& .MuiToolbar-root": {
                                        padding: "12px 16px !important",
                                        margin: "auto !important",
                                        minHeight: "48px !important",
                                        },
                                        "& .MuiFormControl-root": {
                                        margin: "0 !important",
                                        },
                                        "& .MuiInputBase-root": {
                                        marginLeft: "-40px !important",
                                        }
                                    }}
                                    >
                                        <MTableToolbar {...props} />
                                    </Box>
                                </Box>
                        ),
                        }}
                        actions={[
                            {
                                icon: () => (
                                    <Box id="filters" 
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 1,
                                            pb: 0.5
                                        }}>
                                        <CustomToggle
                                            isChecked={inactive}
                                            setIsChecked={handleToggle}
                                            handleToggleChange={handleToggle}
                                            Yestext={"ESI"}
                                            NoText={"EPF"}
                                            style={{
                                                height: "32px",
                                                padding: "0px",
                                                width: "150px",
                                                labelPadding: "2px",
                                                "&:hover": {
                                                    backgroundColor: "#f3edfd !important",
                                                },
                                            }}
                                        />
                                        {data?.length > 0 && (
                                            <Tooltip title={"Export CSV"}>
                                                <span>
                                                    <IconButton onClick={() => handleExport(inactive ? "ESI" : "EPF")} disabled={isCsvLoading}>
                                                        {isCsvLoading ? <CircularProgress size={20} /> : <CloudDownloadIcon />}
                                                    </IconButton>
                                                </span>
                                            </Tooltip>
                                        )}
                                    </Box>
                                ),
                                position: "row",
                                isFreeAction: true,
                            },

                        ]}
                        title=""
                    />  
                </Box>
                <Popup
                    maxWidth="xs"
                    fullWidth={true}
                    title={`Add ${type === "EPF" ? "EPF Number" : type === "ESI" ? "ESI Number" : type === "UAN" ? "UAN Number" : ""}`}
                    openPopup={openPopup}
                    setOpenPopup={setOpenPopup}
                >
                    <Grid container spacing={2}>
                    {type === "EPF" && (
                        <Grid key="name" item xs={12}>
                            <FormControl fullWidth >
                                <TextField
                                    autoFocus
                                    size="small"
                                    value={regData?.pf_no || ""}
                                    onChange={handleInputChange}
                                    variant="outlined"
                                    label="EPF Number"
                                    name="pf_no"
                                    placeholder="AB/XYZ/1234567/001/1234567"
                                    sx={{
                                    "& input::placeholder": {
                                        color: "#B0B0B0",
                                    },
                                    }}
                                    {...(errors.pf_no && {
                                        error: true,
                                        helperText: errors.pf_no,
                                    })}
                                />
                            </FormControl>
                        </Grid>
                    )}
                    { type === "ESI" && (
                        <Grid  item xs={12}>
                        <FormControl fullWidth >
                            <TextField
                                autoFocus
                                size="small"
                                value={regData?.esi_no || ""}
                                onChange={handleInputChange}
                                variant="outlined"
                                label="ESI Number"
                                placeholder="1234567890"
                                name="esi_no"
                                sx={{
                                "& input::placeholder": {
                                color: "#B0B0B0",
                                },
                            }}
                            {...(errors.esi_no && {
                                error: true,
                                helperText: errors.esi_no,
                            })}
                            />
                        </FormControl>
                        </Grid>
                    )}
                    { type === "UAN" && (
                        <Grid  item xs={12}>
                        <FormControl fullWidth >
                            <TextField
                                autoFocus
                                size="small"
                                value={regData?.uan || ""}
                                onChange={handleInputChange}
                                variant="outlined"
                                label="UAN Number"
                                placeholder="123456789012"
                                name="uan"
                                sx={{
                                "& input::placeholder": {
                                color: "#B0B0B0",
                                },
                            }}
                            {...(errors.uan && {
                                error: true,
                                helperText: errors.uan,
                            })}
                            />
                        </FormControl>
                        </Grid>
                    )}
                    <Grid item xs={12} sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 1 }}>
                        <Button
                        variant="outlined"
                        size="small"
                        onClick={() => {setOpenPopup(false); setErrors({})}}
                        >
                        Cancel
                        </Button>
                        <Button
                        variant="outlined"
                        size="small"
                        onClick={handleAddEsicEpfo}
                        disabled={type === "EPF" ? !Boolean(regData?.pf_no) : type === "ESI" ? !Boolean(regData?.esi_no) : type === "UAN" ? !Boolean(regData?.uan) : false}
                        >
                        Add
                        </Button>
                    </Grid>
                    </Grid>
                </Popup>
            </Box>
    );
};

export default EPFOLandingPage;